import { render, staticRenderFns } from "./markBox.vue?vue&type=template&id=12429eee&scoped=true&"
import script from "./markBox.vue?vue&type=script&lang=js&"
export * from "./markBox.vue?vue&type=script&lang=js&"
import style0 from "./markBox.vue?vue&type=style&index=0&id=12429eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12429eee",
  null
  
)

export default component.exports